import { render } from "./About.vue?vue&type=template&id=6d1be178"
const script = {}
script.render = render

export default script